<div class="bio-three">

<h5>Working from home, I was able to keep focusing on the EP. One day at a time, one “you got this” at a time. The songs were feeling heavy, carrying all of the burdens that come with carrying a lifetime of anger and sadness thus far. Even the beach was cloudy and cold, and then I read:</h5>

    <h6><i>“I supplied much needed salt water to this parched earth.”</i></h6>
    
    <h5>And I laughed. And laughed. For 10 minutes straight. My memories of my Nana have always painted her as a wordsmith and very melodramatic, but this? wow, just wow, that’s better than soap opera drama, it’s 21 year old Elizabeth Ann saying goodbye to her boyfriend…for 6 weeks…drama. And I laughed.
   </h5>

</div>